// Project Imports
import apiEndpoint from 'core/common/apiEndPoints';
import resources from 'core/resources/resources';
import { type RolePermission } from 'interfaces/interface';
import type ResourceItem from 'interfaces/resource';
import axiosInstance from 'providers/axiosInstance/axiosInstance';

import DashboardResource from 'core/resources/Dashboard';
import useLogger from 'core/utils/useLogger';
import fetchPrograms from 'core/utils/fetchPrgrams';
import { REACT_APP_USER_API_URL } from 'config';

const fetchPermissions = async (
  setFilteredResources: React.Dispatch<React.SetStateAction<ResourceItem[]>>,
  setCrudPermission: React.Dispatch<React.SetStateAction<string[]>>,
  setModulePermission: React.Dispatch<React.SetStateAction<string[]>>,
  setUserDetails: React.Dispatch<React.SetStateAction<any[]>>,
  changeLanguage: React.Dispatch<React.SetStateAction<any>>,
  setCurrentLang: React.Dispatch<React.SetStateAction<any>>,
  currentLang: any,
  token: any,
  setOrgId: React.Dispatch<React.SetStateAction<string>>,
  setProgramId: React.Dispatch<React.SetStateAction<string>>,
  setUserProgramList: React.Dispatch<React.SetStateAction<any[]>>,
  userSessionId: string
): Promise<void> => {
  try {
    const response = await axiosInstance.get<RolePermission[]>(
      `${REACT_APP_USER_API_URL}/${apiEndpoint.userEvalPermissionDetails}/`
    );
    const responseData = (response.data as any)?.results;
    const crudPermission = responseData?.action_master_list;
    const userDetails = responseData?.user_details;

    const allOtherPermission =
      ['dashboard', 'profile'] +
      responseData.screen_master_list +
      responseData.module_master_list +
      responseData.sub_module_master_list +
      responseData.action_master_list;
    setModulePermission(allOtherPermission);
    setCrudPermission([...crudPermission]);

    const newResources = resources.filter((resource: any) =>
      allOtherPermission.includes(resource.identifier)
    );
    setFilteredResources([DashboardResource, ...newResources]);
    setUserDetails(userDetails);
    localStorage.setItem('userEmailId', userDetails?.user_mail_id || '');

    if (userDetails?.selected_language) {
      changeLanguage(userDetails?.selected_language);
      setCurrentLang(userDetails?.selected_language);
    }
    if (userDetails?.unique_id) {
      axiosInstance.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
        'organization-id': userDetails?.organization_id,
        'Accept-Language': currentLang,
        'role-id': userDetails?.role_id,
        'iprogram-id': userDetails?.iprogram,
        'user-session-id': userSessionId,
      };
      setOrgId(userDetails?.organization_id);
      setProgramId(userDetails?.iprogram);
      await fetchPrograms(userDetails?.iprogram, setUserProgramList);
    }
  } catch (error) {
    const moduleWithAccess = ['dashboard'];
    const newResources = resources.filter((resource: any) =>
      moduleWithAccess.includes(resource.identifier)
    );
    setFilteredResources(newResources);
    const logger = useLogger();
    if (error?.response?.data)
      logger('User permission details error :: ', error?.response?.data);
  }
};

export default fetchPermissions;
